<template>
  <div class="play-container">
    <top-bar :user="this.user" />
    <Menu :user="this.user" :menuSelected="{ campaign: true }" />
    <div class="menu-mobile">
      <div class="user-mobile">
        <div class="close-menu" @click="openMenu(false)">
          <img src="@/assets/images/cms-mkt/x.svg" />
        </div>
        <div class="openNotifications" @click="showModalPopup('modal_popup_mobileNotifications', true)">
          <div class="unread-notifications">
            <span>2</span>
          </div>
          <img src="@/assets/images/cms-mkt/clopotel-alb.svg" />
        </div>

        <div id="modal_popup_mobileNotifications" class="modal-popup">
          <div class="modal-popup-content">
            <a @click="showModalPopup('modal_popup_mobileNotifications', false)" class="close-button">
              <img src="@/assets/images/cms-mkt/close-button.svg" />
            </a>
            <div class="notifications">
              <!-- <NotificationsBox :notifications="this.companyMessages" /> -->
            </div>
          </div>
        </div>

        <div>
          <img src="@/assets/images/cms-mkt/linie.png" />
        </div>
        <div>
          <img src="@/assets/images/cms-mkt/settings.png" />
        </div>
        <div>
          <!-- <a href="#">{{ this.customer.name | titleCase }}</a> -->
        </div>
      </div>
      <Menu :user="this.user" :menuSelected="{ campaign: true }" />
    </div>
    <div class="container-right">
      <div :class="{
        content: true,
        'dashboard-beneficiary': true,
      }">
        <div>
          <div class="account-title ">
            <h1>{{ $t("cmsLang.campaignTitle") }}
              <a @click="addModifyCampaign(null)" class="button-all button-yellow">
                <img src="@/assets/images/cms-mkt/plus.svg" />
                {{ $t('cmsLang.addCampaignLabel') }}
      
              </a>
               </h1>
            <br />
          </div>
          <h2>{{ $t("cmsLang.futureCampaignsTitle") }}</h2>
            <div class="d-flex flex-wrap">

            <div v-if="this.pendingGames === null || this.pendingGames === undefined
            ">
              <div class="loading">
                <!-- <img src="@/assets/images/cms-mkt/loading.gif" /> -->
              </div>
            </div>
            <!-- <div v-else v-for="(offer, index) in submittedGames" :key="index" class="content-delivery"> -->
            <campaign-case v-else v-for="(entry, index) in pendingGames" :key="index" :campaign="entry" :user="user"
              :editable="true" @edit="addModifyCampaign"  @delete="addModifyCampaign"
              @showdetails="showDetails" />
          </div>
          <br />

          <h2>{{ $t("cmsLang.pastCampaignsTitle") }}</h2>
          <div class="d-flex flex-wrap">
            <div v-if="this.submittedGames === null || this.submittedGames === undefined
            ">
              <div class="loading">
                <img src="@/assets/images/cms-mkt/loading.gif" />
              </div>
            </div>
            <div v-else class="d-flex flex-wrap">
              <campaign-case v-for="(entry, index) in submittedGames" :key="index" :campaign="entry" :user="user"
              :editable="false" @showdetails="showDetails" />
            </div>
          </div>

        </div>

      </div>
    </div>

    <campaign-popup  :notification="this.selectedGame" :user="this.user" 
      @updatelist="getAllSubmittedGames" @showinfo="showPopupInfo" />
    <campaign-details-popup :campaign="this.selectedGame" :user="this.user" @edit="addModifyCampaign"
      @delete="addModifyCampaign" />
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_info', false)" class="close-button">
          <img src="@/assets/images/cms-mkt/close-button.svg" />
        </a>
        <br />
        <div v-if="this.error">
           <p  v-if="this.error.error_code">
              {{ this.error.description ? this.error.description : $t('cmsLang.errorMessage_' + this.error.error_code) }}
            </p>
            <p v-else class="error" v-for="(error, index) in this.error" :key="index">
            {{ error.description ? error.description : $t('cmsLang.errorMessage_' + error.error_code) }}
            </p>        </div>
        <div v-else>
          <br />
          <p>{{ $t('cmsLang.' + this.successMessage) }}</p>
        </div>
      </div>
    </div>

    <!-- <modal-loading /> -->
    <ResetPassword v-if="this.isUserNew(this.user)" :user="this.user" />
    <!-- <PartnersPopup :user="this.user" @showinfo="showPopupInfo" /> -->

  </div>
</template>

<script>
  import Menu from "@/components/cms-mkt/Menu.vue";
  import TopBar from "@/components/cms-mkt/TopBar.vue";
  import Cookies from "js-cookie";
  import httpServiceCustomer from "@/http/http-play.js";
  import CampaignCase from "@/components/fragments/cms-mkt/CampaignCase.vue";
  import CampaignPopup from "@/components/fragments/cms-mkt/NewCampaignPopup.vue";
  import CampaignDetailsPopup from "@/components/fragments/cms-mkt/CampaignDetailsPopup.vue";
  import ResetPassword from "@/components/fragments/cms-mkt/ResetPasswordPopup.vue";
  // import PartnersPopup from "@/components/fragments/cms-mkt/ManagePartnerPopup.vue";
  import utils from "@/plugins/utils.js";

  // import ModalLoading from "@/components/fragments/cms-mkt/ModalLoading.vue";

  export default {
    name: "smsCampaign",

    components: {
      // ModalLoading,
      CampaignPopup,
      CampaignDetailsPopup,
      TopBar,
      CampaignCase,
      Menu,
      ResetPassword,
      // PartnersPopup
    },
    data() {
      return {
        user: null,
        // gameTypes: ["N", "Y"],
        gameTypes: ["N"],
        filter: {
          type: "OFFER",
          person: null
        },
        selectedGameType: "",
        sortBy: ["NEW", "OLD"],
        sortBySelected: "NEW",
        sortField: "id",
        sortDirection: "desc",
        submittedGames: null,
        pendingGames: null,
        error: null,
        perPage: 10000,
        deleteSuccess: false,
        selectedGame: null,
        selectedGames: [],
        successMessage: "",
        isLoading: false,
        action: '',
        categories: null

      };
    },
    methods: {
      addModifyCampaign(game, label) {
        this.selectedGameType = "";
        this.action = "edit"
        this.error = null;
        this.showModalPopup("modal_popup_campaign_details", false);
        this.selectedGame = null;
        if (!game) {
          this.selectedGame = {
            id: 0,
          };
          this.showModalPopup("modal_popup_campaign", true);
          // }
        } else {
          this.getCampaignDetails(game.id);
        }
      },
      showDetails(game) {
        console.log(game);
        this.action = "details";
        this.getCampaignDetails(game.id);
      },
      getAllSubmittedGames() {
        this.getSubmittedCampaigns(false);
        this.getSubmittedCampaigns(true);
      },
      showPopupInfo(successMessage, error) {
        this.selectedGameType = "";
        this.successMessage = successMessage;
        this.error = error;
        // this.showModalPopup("modal_popup_partners", false);
        if (this.successMessage.length > 0){
          this.showModalPopup("modal_popup_campaign", false);
        }
        this.showModalPopup("modal_popup_loading_cms", false);
        this.showModalPopup("modal_popup_info", true);
      },
      getSubmittedCampaigns(pending) {
        var formData = {
          per_page: this.perPage,
          page: this.currentPage,
          sort: this.sortDirection
        };
        if (pending) {
          formData.status = "N";
        } else {
          formData.status = "V";
        }
        this.selectedGameType = "";
        this.selectedGames = [];
        // var offersData = "?type=M";
        // offersData += "&status=A,S";
        // if (this.filters.content) {
        //   formData.content = this.filters.content.trim();
        // }
        // if (this.reverse) {
        //   formData.sort = "desc";
        //   formData.desc = [this.sortByField];
        // } else {
        //   formData.sort = "asc";
        //   formData.asc = [this.sortByField];
        // }
        if (this.sortDirection === "desc") {
          formData.desc = [this.sortField];
        } else {
          formData.asc = [this.sortField];
        }

        this.submittedGames = null;
        httpServiceCustomer.customerService
          .searchCampaigns(formData, Cookies.get("token"))
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            this.error = {
              code: error.response.data,
              description: error.response.data,
            };
          })
          .then((response) => {
            if (response.status == 200) {
              if (pending) {
                this.pendingGames = response.data;
              } else {
                this.submittedGames = response.data;
              }
              // this.invoicesCount = response.headers["x-up-count"]; //["Content-Length"];
            } else if (response.status == 400 || response.status == 403) {
              this.error = {
                code: response.data,
                description: response.data,
              };
              // this.showModalPopup("modal_popup_loading_cms", false);
              this.showModalPopup("modal_popup_info", true);
            } else {
              this.error = { description: response.description };
              // this.showModalPopup("modal_popup_loading_cms", false);
              this.showModalPopup("modal_popup_info", true);
            }
          });
      },
      sortByChanged(event) {
        this.sortBySelected = event.target.value;
        switch (this.sortBySelected) {
          case "NEW":
            this.sortField = "valstdate";
            this.sortDirection = "desc";
            break;
          case "OLD":
            this.sortField = "valstdate";
            this.sortDirection = "asc";
            break;
          default:
            this.sortField = "valstdate";
            this.sortDirection = "desc";
        }
        this.getSubmittedCampaigns(false);
      },
      selectFilterType(entry) {
        this.filter.type = entry;
        this.getSubmittedCampaigns();

      },
      getCampaignDetails(gameId) {
        this.showModalPopup("modal_popup_loading_cms", true);
        this.selectedGame = {};

        httpServiceCustomer.customerService
          .getCampaignDetails(gameId, Cookies.get("token"))
          .then(function (response) {
            return response;
          })
          .then((response) => {
            if (response.status == 200) {
              this.selectedGame = response.data;

              this.showModalPopup("modal_popup_loading_cms", false);

              switch (this.action) {
                case "edit":
                  this.showModalPopup("modal_popup_campaign", true);
                  break;
                case "details":
                  this.showModalPopup("modal_popup_campaign_details", true);
                  break;
              }
            } else {
              this.error = {
                code: response.data.code,
              };
            }
          })
          .catch((error) => {
            this.error = { code: error.response.code };
            this.showModalPopup("modal_popup_loading_cms", false);
          });
      },
    },
    mounted() {
      this.getAllSubmittedGames();
    },
    computed: {},
    created() {
      this.user = this.getUser();

    },
  };
</script>

<style scoped src="@/assets/styles/mkt-cms.css" />
<style src="vue-multiselect/dist/vue-multiselect.min.css" />
<style src="@/assets/styles/multiselect.css" />

<style scoped>
  .right {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }

  .left {
    padding: 10px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
  }

  .left small {
    padding-right: 10px;
  }

  .left .status_11 {
    color: #FF0000;
  }

  .left .status_10 {
    color: #7ea800;
  }

  .left .status_12 {
    color: #FF0000;
  }

  .left .status_13 {
    color: #3C4645;
  }

  .content-delivery {
    flex-direction: column;
    margin-bottom: 20px;
  }

  .content-delivery .personimg {
    width: 64px;
    height: 64px;
    border-radius: 100%;
    margin: 20px;
  }

  .offer_header {
    width: 100%;
    border-bottom: 1px solid #dcdee3;
    display: flex;
    justify-content: space-between;
    padding: 5px 0;
  }

  .offer_details {
    display: flex;
    flex-direction: row;
    width: 100%;
  }

  .offer_details .image {
    max-width: 80px;
    max-height: 80px;
    margin: 10px;
    padding: 30px;
  }

  .offer_details .imageDiv {
    /* height: 128px;
  width: 128px !important;
  margin: 10px; */
    border-radius: 100%;
    border: 1px solid #dcdee3;
    margin: 10px;
    width: 140px;
    height: 140px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .button-red {
    border: 1px solid #FF0000;
    border-radius: 100px !important;
  }

  .multiselect {
    width: 50% !important;
    border: 1px solid #d8d8d8;
    background: #f1f1f1 !important;

  }

  .margin-y-10 {
    margin-top: 15px;
    margin-bottom: 15px;
  }
</style>
